module.exports = __webpack_public_path__ + "img/isa_logo.30f31bc0.png";